import { S } from './fontAwesomeIconMap.styles';

export const fontAwesomeIconMap = {
  'time-field-clock': { name: 'clock', variant: 'light' },
  'time-picker-angle-up': { name: 'angle-up' },
  'time-picker-angle-down': { name: 'angle-down' },
  'nested-checklist-expand-arrow': { name: 'angle-down', css: S.nestedChecklistExpandArrow },
  'accordion-item-arrow': { name: 'angle-down' },
  'accordion-item-plus': { name: 'plus' },
  'accordion-item-minus': { name: 'minus' },
  'alert-close': { name: 'x', css: S.alertClose },
  'combo-box-delete': { name: 'x', variant: 'light' },
  'modal-close': { name: 'x', css: S.modalClose },
  'select-down': { name: 'angle-down', css: S.selectDown },
  'switch-off': { name: 'x' },
  'switch-on': { name: 'check' },
  'collapsible-menu-submenu-arrow': { name: 'angle-down', css: S.collapsibleMenuSubmenuArrow },
  'hamburger-menu-bars': { name: 'bars' },
  'dropdown-indicator-right': { name: 'angle-right', css: S.dropdownIndicatorRight },
  'dropdown-arrow-up': { name: 'angle-up' },
  'dropdown-arrow-down': { name: 'angle-down' },
  'combo-box-item-selected': { name: 'check' },
  'date-field-calendar': { name: 'calendar', variant: 'regular' },
  'calendar-angle-left': { name: 'angle-left', variant: 'light' },
  'calendar-angle-right': { name: 'angle-right', variant: 'light' },
  'combo-box-clear': { name: 'x', variant: 'light', css: S.comboBoxClear },
  'vertical-navigation-arrow-up': { name: 'angle-up' },
  'vertical-navigation-arrow-down': { name: 'angle-down' },
  'password-field-hide': { name: 'eye-slash', variant: 'solid' },
  'password-field-show': { name: 'eye', variant: 'solid' },
  'pdf-download': { name: 'download', variant: 'sharp-solid' },
  'file-manager-delete': { name: 'x', variant: 'light' },
  'cmd-table-check': { name: 'check', variant: 'solid' },
  'cmd-table-link': { name: 'arrow-up-right-from-square', variant: 'regular' },
  print: { name: 'print' },
  'onboarding-imprint': { name: 'circle-info', variant: 'light' },
  'section-toggle': { name: 'angle-down' },
  'data-grid-boolean-false': { name: 'x', variant: 'light' },
  'data-grid-boolean-true': { name: 'check', variant: 'regular' },
  'data-grid-columns': { name: 'line-columns', variant: 'duotone' },
  'data-grid-context-menu': { name: 'ellipsis-vertical', variant: 'regular' },
  'data-grid-context-menu-hide-column': { name: 'eye-slash', variant: 'solid' },
  'data-grid-density': { name: 'line-height' },
  'data-grid-expand': { name: 'angle-right', variant: 'regular' },
  'data-grid-export': { name: 'download', variant: 'regular' },
  'data-grid-filter': { name: 'filter', variant: 'regular' },
  'data-grid-pin-left': { name: 'thumbtack', variant: 'regular' },
  'data-grid-pin-right': { name: 'thumbtack', variant: 'regular' },
  'data-grid-sort-asc': { name: 'arrow-up', variant: 'regular' },
  'data-grid-sort-desc': { name: 'arrow-down', variant: 'regular' },
  'checkbox-check': { name: 'check' },
  'tree-graph-plus': { name: 'plus' },
  'tree-graph-minus': { name: 'minus' },
  'tree-graph-fit-view': { name: 'expand' },
  'tree-graph-expand': { name: 'angle-down' },
} as const;
